<!--
 * @Description: 派单权弹框
 * @Author: fengal
 * @Date: 2023-02-06 16:43:52
-->
<template>
  <div class="body">
    <el-dialog class="dispatch" width="1032px" title="医院派单权" :visible.sync="visible" :close-on-click-modal="false" @open="initData" :before-close='handleCancel' center>
      <div class="attendant">
        {{attendant.attendantName}}
        <span>
          {{attendant.institutionName}}
        </span>
      </div>
      <el-checkbox v-model="attendant.dispatchPvgFlag" style="margin-left: 25px;" @change="(val) => handleChangeDispatch(val)">派单权</el-checkbox>
      <div class="signedHospital">
        <div class="content">
          <div class="hspList">
            <div class="title">
              <span>医院列表</span>
            </div>
            <el-checkbox class="checkedAll" v-model="attendant.checkedAllHsp" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</el-checkbox>
            <div class="hsp" v-for="(item, index) in signedHospital" :key="item.hospitalId" :class="item.hospitalId == curHsp.hospitalId ? 'activeHsp' : 'commonHsp'" @click.stop="handleClickHsp(item)">
              <el-checkbox v-model="item.hospitalSelectFlag" :true-label="1" :false-label="0" @change="(val)=>handlehospitalSelectFlagChange(val, index)"></el-checkbox>
              <span>
                {{item.hospitalName}}
              </span>
            </div>
          </div>
          <div class="deptList">
            <div class="title">
              <span>科室列表</span>
            </div>
            <div class="filter-box" v-show="curDeptList.length">
              <el-input placeholder="搜索" prefix-icon="el-icon-search" size="small" v-model="filterDeptText"></el-input>
            </div>
            <el-checkbox class="checkedAll" v-show="curDeptList.length" v-model="checkedAllDept" :indeterminate="isIndeterminateDept" @change="handleCheckAllDeptChange">全选</el-checkbox>
            <el-tree :data="curDeptList" show-checkbox default-expand-all node-key="id" ref="deptTree" highlight-current :props="defaultDeptProps" :default-checked-keys="checkedDeptKeys" :filter-node-method="filterNode" @check="handleCheckDeptChange">
            </el-tree>
          </div>
          <div class="serviceList">
            <div class="title">
              <span>服务列表</span>
            </div>
            <div class="filter-box" v-show="curServiceList.length">
              <el-input placeholder="搜索" prefix-icon="el-icon-search" size="small" v-model="filterServiceText"></el-input>
            </div>
            <el-checkbox class="checkedAll" v-show="curServiceList.length" v-model="checkedAllService" :indeterminate="isIndeterminateService" @change="handleCheckAllServiceChange">全选</el-checkbox>
            <el-tree :data="curServiceList" show-checkbox default-expand-all node-key="id" ref="serviceTree" highlight-current :props="defaultServiceProps" :default-checked-keys="checkedServiceKeys" 
              :filter-node-method="filterNode" @check="handleCheckServiceChange">
            </el-tree>
          </div>
        </div>
      </div>
      <div class="bk-wizard-bottons" style="text-align: center;">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 派单权限对话框 -->
    <cancle-dispatch-privilege-dialog :visible="showCancleDispatchDialog" :id="curAttendant.id" 
    :institutionId="attendant.institutionId" :cancleDispatchMessage="cancleDispatchMessage" :hospitalDepartmentDOList="rmvHspDeptDOList"
    :hospitalHserviceDOList="rmvHspHsvcDOList" @close-dialog="closeCancleDispatchPrivilegeDialog" />
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import CancleDispatchPrivilegeDialog from './CancleDispatchPrivilegeDialog.vue'

export default {
  name: 'SetupDispatchPvg',
  props: ['visible', 'attendantId', 'curAttendant'],

  components: {
    'cancle-dispatch-privilege-dialog': CancleDispatchPrivilegeDialog,
  },

  data() {
    return {
      attendant: {},
      signedHospital: [],
      allHospital: [],
      hospitalHserviceDOList: [],
      rmvHspDeptDOList: [],
      rmvHspHsvcDOList: [],
      showCancleDispatchDialog: false,
      cancleDispatchMessage: null,
      targetAttendant: {},
      isIndeterminate: true,
      selectedHospital: [],
      curHsp: {},
      curDeptList: [],
      checkedAllDept: false,
      isIndeterminateDept: true,
      defaultDeptProps: {
        children: 'department2List',
        label: 'name',
      },
      checkedDeptKeys: [],
      filterDeptText: '',

      curServiceList: [],
      checkedAllService: false,
      isIndeterminateService: true,
      defaultServiceProps: {
        children: 'hserivceModeList',
        label: 'name',
      },
      checkedServiceKeys: [],
      filterServiceText: '',
    }
  },

  methods: {
    async initData() {
      await this.getAttendantDoDispatchPvg()
    },

    getAttendantDoDispatchPvg() {
      return new Promise((resolve) => {
        let params =  {attendantId: this.attendantId}
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_ATTENDANT_DO_DISPATCH_PVG,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return
          }
          this.$set(this, 'attendant', result.data || {})
          this.signedHospital = result.data.hospitalDepartmentDOList || []
          this.hospitalHserviceDOList = result.data.hospitalHserviceDOList || []

          if (this.hospitalHserviceDOList.length > 0) {
            this.curServiceList = this.hospitalHserviceDOList[0].hserviceModeDTOList || []
          }

          if (this.signedHospital.length > 0) {
            this.curHsp = this.signedHospital[0] || {}

            this.curDeptList = this.curHsp.department1List || []
          }

          resolve(result.data)
        })
      })
    },

    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    handleChangeDispatch(val) {
      if (!this.selectedHospital.length && val) this.$set(this.attendant, 'dispatchPvgFlag', false)
    },

    // 选中医院
    getSelHospital(data) {
      const arr = JSON.parse(JSON.stringify(data));
      const result = [];

      for (const obj of arr) {
        if (obj.hospitalSelectFlag === 1 && !obj.deptPartSelectFlag) {
          result.push({
            hospitalId: obj.hospitalId,
            hospitalName: obj.hospitalName + '(全部科室)',
          });
        } else if (obj.hospitalSelectFlag === 1) {
          const hospitalName = this.generateHospitalName(obj);
          if (hospitalName) {
            result.push({
              hospitalId: obj.hospitalId,
              hospitalName: hospitalName
            });
          }
        }
      }

      this.$set(this, 'selectedHospital', result);
      if (!this.selectedHospital.length) this.$set(this.attendant, 'dispatchPvgFlag', false);
    },

    generateHospitalName(obj) {
      const selectedDepts = [];
      for (const dept1 of obj.department1List) {
        const dept1Names = [];
        if (dept1.selectFlag === 1) {
          selectedDepts.push(dept1.name);
        } else {
          for (const dept2 of dept1.department2List) {
            if (dept2.selectFlag === 1) {
              dept1Names.push(dept2.name);
            }
          }
          if (dept1Names.length > 0) {
            selectedDepts.push(dept1.name + '-' + dept1Names.join('、'));
          }
        }
      }
      return selectedDepts.length > 0 ? obj.hospitalName + '(' + selectedDepts.join(';  ') + ')' : null;
    },

    // 数据结构处理
    updateCheckedDepts(arr) {
      this.checkedDeptKeys = [];

      for (const hospital of arr) {
        for (const dept of hospital.department1List) {
          if (dept.selectFlag === 1) {
            const uncheckedDept2Count = this.processDepartment2List.call(this, dept.department2List);
            if (uncheckedDept2Count !== 0) {
              dept.selectFlag = 0;
            }
          }
        }
      }

      return arr;
    },

    processDepartment2List(department2List) {
      let uncheckedDept2Count = 0;
      for (const dept2 of department2List) {
        if (dept2.selectFlag === 1) {
          this.checkedDeptKeys.push(dept2.id);
        } else {
          uncheckedDept2Count++;
        }
      }
      return uncheckedDept2Count;
    },

    // 转移未完成订单弹框确认/取消
    closeCancleDispatchPrivilegeDialog(refresh, targetAttendantId) {
      this.showCancleDispatchDialog = false
      if (!refresh) return
      this.targetAttendant.orderIdList = this.cancleDispatchMessage.orderDTOList.map((item) => {
        return item.id
      })
      this.targetAttendant.targetAttendantId = targetAttendantId
      const { attendantId, attendantName, institutionId, institutionName, dispatchPvgFlag } =
        this.attendant
      let obj = { attendantId, attendantName, institutionId, institutionName, dispatchPvgFlag }
      if (this.cancleDispatchMessage.hasIncompleteOrder) obj = { ...obj, ...this.targetAttendant }
      obj.hasIncompleteOrder = this.cancleDispatchMessage.hasIncompleteOrder
      obj.hospitalDepartmentDOList = this.updateSelectFlag(this.signedHospital)
      obj.hospitalHserviceDOList = this.updateSelectFlag(JSON.parse(JSON.stringify(this.hospitalHserviceDOList)))
      this.updateDispatch(obj)
    },

    // 删除可派单医院tag
    handleClose(id) {
      const idx = this.signedHospital.findIndex((item) => item.hospitalId == id)
      if (idx < 0) return
      this.handlehospitalSelectFlagChange(0, idx)
      this.signedHospital[idx].hospitalSelectFlag = 0
      if (this.signedHospital.findIndex((item) => item.hospitalSelectFlag) === -1)
        this.$set(this.attendant, 'checkedAllHsp', false)
      if (!this.selectedHospital.length) this.$set(this.attendant, 'dispatchPvgFlag', false)
    },

    // 设置当前选中科室下的默认选中项
    setSelDeptKeys() {
      this.checkedDeptKeys = [];
      this.curDeptList.forEach((item) => {
        if (item.selectFlag) this.checkedDeptKeys.push(item.id)
        item.department2List.forEach((dept) => {
          if (dept.selectFlag) this.checkedDeptKeys.push(dept.id)
        })
      })
    },

    // 设置当前选中服务下的默认选中项
    setSelServiceKeys() {
      this.checkedServiceKeys = [];
      this.curServiceList.forEach((item) => {
        if (item.selectFlag) this.checkedServiceKeys.push(item.id)
        item.hserivceModeList.forEach((svc) => {
          if (svc.selectFlag) this.checkedServiceKeys.push(svc.id)
        })
      })
    },

    // 医院派单权状态修改
    handlehospitalSelectFlagChange(val, index) {
      this.signedHospital[index].deptPartSelectFlag = false
      this.signedHospital[index].hospitalSelectFlag = val ? 1 : 0
      Array.from(this.signedHospital[index].department1List, (dept) => {
        dept.selectFlag = val ? 1 : 0
        Array.from(dept.department2List, (dept2) => (dept2.selectFlag = val ? 1 : 0))
        return dept
      })
      if (this.curHsp.hospitalId === this.signedHospital[index].hospitalId) {
        this.curDeptList = this.signedHospital[index].department1List
      }
      this.curServiceList = this.hospitalHserviceDOList[index].hserviceModeDTOList || [];
      this.$set(
        this.attendant,
        'dispatchPvgFlag',
        val || this.selectedHospital.length ? true : false
      )
      // 修改服务列表全选
      this.handleCheckAllServiceChange(val);
    },

    // 医院全选状态修改
    handleCheckAllChange(val) {
      // 修改
      this.setHospitalSelectFlags(val);
      this.setDispatchPvgFlag(val);
      this.setcheckedDeptKeys(val);
      this.setIndeterminateDept(false);
      // 修改服务列表全选
      this.setServiceSelectFlags(val);
    },

    setHospitalSelectFlags(val) {
      for (const item of this.signedHospital) {
        item.hospitalSelectFlag = val ? 1 : 0;
        item.deptPartSelectFlag = false;
        this.setDeptSelectFlags(item.department1List, val);
      }
    },

    setDeptSelectFlags(department1List, val) {
      for (const dept of department1List) {
        dept.selectFlag = val ? 1 : 0;
        this.setDept2SelectFlags(dept.department2List, val);
      }
    },

    setDept2SelectFlags(list, val) {
      for (const dept2 of list) {
        dept2.selectFlag = val ? 1 : 0;
      }
    },

    setDispatchPvgFlag(val) {
      this.$set(this.attendant, 'dispatchPvgFlag', val);
    },

    setServiceSelectFlags(val) {
      for (const item of this.hospitalHserviceDOList) {
        item.hospitalSelectFlag = val ? 1 : 0;
        item.deptPartSelectFlag = false;
        this.setHvcSelectFlags(item.hserviceModeDTOList, val);
      }
    },

    setHvcSelectFlags(hserviceModeDTOList, val) {
      for (const dept of hserviceModeDTOList) {
        dept.selectFlag = val ? 1 : 0;
        this.setDept2SelectFlags(dept.hserivceModeList, val);
      }
    },

    // 设置树状科室勾选项
    setcheckedDeptKeys(val) {
      this.checkedDeptKeys = [];
      if (val) {
        this.checkedAllDept = true;
        for (const item of this.curDeptList) {
          this.checkedDeptKeys.push(item.id);
        }
      } else {
        this.checkedAllDept = false;
        this.$refs.deptTree.setCheckedKeys([]);
      }
    },

    // 设置树状科室全选不确定项
    setIndeterminateDept(val) {
      this.isIndeterminateDept = val;
    },

    // 科室全选状态修改
    handleCheckAllDeptChange(val) {
      console.log(val)
      this.checkedDeptKeys = []
      this.checkedAllDept = val ? true : false
      this.isIndeterminateDept = false

      this.curDeptList.forEach((item) => {
        if (val) this.checkedDeptKeys.push(item.id)
        item.selectFlag = val ? 1 : 0
        item.department2List.forEach((item2) => {
          item2.selectFlag = val ? 1 : 0
        })
      })

      if (!val) {
        this.$refs.deptTree.setCheckedKeys([])
      }

      let index = this.signedHospital.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      let flag = val ? 1 : 0
      this.$set(this.signedHospital[index], 'department1List', this.curDeptList)
      this.$set(this.signedHospital[index], 'hospitalSelectFlag', flag)
      this.$set(this.signedHospital[index], 'deptPartSelectFlag', false)
    },

    // 服务全选状态修改
    handleCheckAllServiceChange(val) {
      console.log(val)
      this.checkedServiceKeys = []
      this.checkedAllService = val ? true : false
      this.isIndeterminateService = false

      this.curServiceList.forEach((item) => {
        if (val) this.checkedServiceKeys.push(item.id)
        item.selectFlag = val ? 1 : 0
        item.hserivceModeList.forEach((item2) => {
          item2.selectFlag = val ? 1 : 0
        })
      })

      if (!val) {
        this.$refs.serviceTree.setCheckedKeys([])
      }

      // 找到对应序列医院
      let index = this.hospitalHserviceDOList.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      let flag = val ? 1 : 0
      this.$set(this.hospitalHserviceDOList[index], 'hserviceModeDTOList', this.curServiceList)
      this.$set(this.hospitalHserviceDOList[index], 'hospitalSelectFlag', flag)
      // 修改对应医院选中状态
      this.$set(this.signedHospital[index], 'hospitalSelectFlag', flag)
    },

    // 切换当前选中医院
    handleClickHsp(item) {
      this.curHsp = item
      this.curDeptList = this.curHsp.department1List

      this.hospitalHserviceDOList.forEach(hsp => {
        if (hsp.hospitalId === item.hospitalId) {
          this.curServiceList = hsp.hserviceModeDTOList || []
          return false
        }
      });
    },

    // 科室列表树选中状态修改
    handleCheckDeptChange() {
      let checkArr = this.$refs.deptTree.getCheckedKeys()
      this.curDeptList.forEach((item) => {
        item.selectFlag = 0
        if (checkArr.includes(item.id)) {
          item.selectFlag = 1
        }
        item.department2List.forEach((dept) => {
          dept.selectFlag = 0
          if (checkArr.includes(dept.id)) {
            dept.selectFlag = 1
            return false
          }
        })
      })

      let arr = []
      this.curDeptList.forEach((item) => {
        arr.push(item.id)
        item.department2List.forEach((dept) => {
          arr.push(dept.id)
        })
      })
      if (!checkArr.length) {
          this.checkedAllDept = false
          this.isIndeterminateDept = false
        } else if (checkArr.length === arr.length) {
          this.checkedAllDept = true
          this.isIndeterminateDept = false
        } else {
          this.checkedAllDept = true
          this.isIndeterminateDept = true
        }

      let index = this.signedHospital.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      let flag =  this.checkedAllDept ? 1 : 0
      this.$set(this.signedHospital[index], 'department1List', this.curDeptList)
      this.$set(this.signedHospital[index], 'hospitalSelectFlag', flag)
      this.$set(this.signedHospital[index], 'deptPartSelectFlag', this.isIndeterminateDept)
    },

    // 服务列表树选中状态修改
    handleCheckServiceChange() {
      let checkArr = this.$refs.serviceTree.getCheckedKeys()
      this.curServiceList.forEach((item) => {
        item.selectFlag = 0
        if (checkArr.includes(item.id)) {
          item.selectFlag = 1
        }
        item.hserivceModeList.forEach((Service) => {
          Service.selectFlag = 0
          if (checkArr.includes(Service.id)) {
            Service.selectFlag = 1
            return false
          }
        })
      })

      let arr = []
      this.curServiceList.forEach((item) => {
        arr.push(item.id)
        item.hserivceModeList.forEach((service) => {
          arr.push(service.id)
        })
      })
      if (!checkArr.length) {
          this.checkedAllService = false
          this.isIndeterminateService = false
        } else if (checkArr.length === arr.length) {
          this.checkedAllService = true
          this.isIndeterminateService = false
        } else {
          this.checkedAllService = true
          this.isIndeterminateService = true
        }

      let index = this.hospitalHserviceDOList.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      let flag =  this.checkedAllService ? 1 : 0
      this.$set(this.hospitalHserviceDOList[index], 'hserviceModeDTOList', this.curServiceList)
      this.$set(this.hospitalHserviceDOList[index], 'hospitalSelectFlag', flag)
      this.$set(this.signedHospital[index], 'hospitalSelectFlag', flag)
    },

    // 数据结构处理
    updateSelectFlag(arr) {
      let hospitals = JSON.parse(JSON.stringify(arr))
      
      for (let item of hospitals) {
        delete item.deptAllSelectFlag;
        delete item.deptPartSelectFlag;
      }
      return hospitals
    },

    // 发起修改派单权请求
    updateDispatch(obj) {
      let header = this.encryptionUtil.signatureBody({...obj},
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_SAVE_ATTENDANT_DISPATCH_PVG,
        param: obj,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return
        }
        this.$emit('close-dialog', true)
      })
    },

    // 查询护工是否还有未完成订单
    getDispatchCelDO(data) {
			let [header, esParam] = this.encryptionUtil.encryptAndSignBody(data,
				Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_GET_ATTENDANT_CANCEL_DISPATCH_DO,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) return
        this.cancleDispatchMessage = result.data
        this.attendant.hasIncompleteOrder = result.data.hasIncompleteOrder
        if (result.data.hasIncompleteOrder) {
          // 订单转移弹框展示用
          this.rmvHspDeptDOList = result.data.hospitalDepartmentDOList || []
          this.rmvHspHsvcDOList = result.data.hospitalHserviceDOList || []
          // 有未完成订单则展示确认框
          this.isRmoveDisoatch()
        } else {
          // 无未完成订单直接发送修改派单权请求
          const { attendantId, attendantName, institutionId, institutionName, dispatchPvgFlag } =
            this.attendant
          let obj = { attendantId, attendantName, institutionId, institutionName, dispatchPvgFlag }
          obj.hasIncompleteOrder = false
          obj.hospitalDepartmentDOList = this.updateSelectFlag(this.signedHospital)
          obj.hospitalHserviceDOList = this.updateSelectFlag(JSON.parse(JSON.stringify(this.hospitalHserviceDOList)))
          this.updateDispatch(obj)
        }
      })
    },

    // 是否转移订单确认框
    isRmoveDisoatch() {
      this.$confirm(
        `${
          this.cancleDispatchMessage.attendantName
        }在${this.cancleDispatchMessage.hospitalDepartmentTextList.join(',')}
        有未完成的订单，暂无法直接取消其派单权，如需立即取消，可先将派单权转移至他人！`,
        '请谨慎操作',
        {
          confirmButtonText: '转移订单',
          cancelButtonText: '暂不取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.showCancleDispatchDialog = true
        })
        .catch(() => {
          this.cancleDispatchMessage = {}
          delete this.attendant.hasIncompleteOrder
        })
    },

    handleSubmit() {
      // 校验--派单权勾选医院时，科室和服务必选
      if (this.validaHsp()) return this.$message.error(this.validaHsp());


      let dispatchPvgFlag = this.attendant.dispatchPvgFlag
      let hospitalDepartmentDOList = this.updateSelectFlag(this.signedHospital)
      let hospitalHserviceDOList = this.updateSelectFlag(this.hospitalHserviceDOList)
      let dispatchWithDempartmentVO = {
        hospitalDepartmentDOList: hospitalDepartmentDOList,
        hospitalHserviceDOList: hospitalHserviceDOList,
        dispatchPvgFlag: dispatchPvgFlag,
        attendantId: this.attendant.attendantId
      }
      this.getDispatchCelDO(dispatchWithDempartmentVO)
    },

    validaHsp() {
      for (const [index, hsp] of this.signedHospital.entries()) {
        if (hsp.hospitalSelectFlag === 1) {
            // 检查一级科室或二级科室是否选择
            const hasSelectedDepartment = hsp.department1List.some(department1 => {
                return department1.selectFlag === 1 || (department1.department2List && department1.department2List.some(department2 => department2.selectFlag === 1));
            });

            // 检查服务或二级服务是否选择
            const hasSelectedService = this.hospitalHserviceDOList[index].hserviceModeDTOList.some(hsvc => {
                return hsvc.selectFlag === 1 || (hsvc.hserivceModeList && hsvc.hserivceModeList.some(subHsvc => subHsvc.selectFlag === 1));
            });

            // 如果一级科室或二级科室或服务有任意一个选择了，就通过校验
            if (!(hasSelectedDepartment && hasSelectedService)) {
                return `${hsp.hospitalName} 请至少选择一个科室和一个服务`;
            }
        }
      }
    },

    handleCancel() {
      this.clearData()
      this.$emit('close-dialog', false)
    },

    clearData() {
      this.filterDeptText = ''
      this.attendant = {}
      this.hospital = []
      this.signedHospital = []
      this.cancleDispatchMessage = {}
      this.targetAttendant = {}
    },
  },

  watch: {
    filterDeptText(val) {
      this.$refs.deptTree.filter(val)
    },

    filterServiceText(val) {
      this.$refs.serviceTree.filter(val)
    },

    signedHospital: {
      handler(newVal, _oldVal) {
        const count1 = this.signedHospital.filter(
          (hospital) => hospital.hospitalSelectFlag === 1 && !hospital.deptPartSelectFlag
        ).length
        const count2 = this.signedHospital.filter(
          (hospital) => hospital.hospitalSelectFlag === 0).length

          if (count1 === this.signedHospital.length) {
          this.isIndeterminate = false
          this.$set(this.attendant, 'checkedAllHsp', true)
        } else if (count2 === this.signedHospital.length) {
          this.isIndeterminate = false
          this.$set(this.attendant, 'checkedAllHsp', false)
        } else {
          this.isIndeterminate = true
          this.$set(this.attendant, 'checkedAllHsp', false)
        }
        this.getSelHospital(newVal)
      },
      deep: true,
      immediate: true,
    },

    curDeptList: {
      handler: function(newVal, _oldVal) {
        // 设置tree默认选中项
        this.setSelDeptKeys()
        // 获取一级tree节点选中个数
        const trueFlagCount = newVal.filter(obj => obj.selectFlag).length;
        if (!this.checkedDeptKeys.length) {
          // 不选
          this.$refs.deptTree.setCheckedKeys([])
          this.checkedAllDept = false;
          this.isIndeterminateDept = false;
        } else if (trueFlagCount === newVal.length) {
          // 全选
          this.checkedAllDept = true;
          this.isIndeterminateDept = false;
        } else {
          // 部分选
          this.checkedAllDept = true;
          this.isIndeterminateDept = true;
        }
      },
      deep: true,
    },

    curServiceList: {
      handler: function(newVal, _oldVal) {
        // 设置tree默认选中项
        this.setSelServiceKeys()
        // 获取一级tree节点选中个数
        const trueFlagCount = newVal.filter(obj => obj.selectFlag).length;
        if (!this.checkedServiceKeys.length) {
          // 不选
          this.$refs.serviceTree.setCheckedKeys([])
          this.checkedAllService = false;
          this.isIndeterminateService = false;
        } else if (trueFlagCount === newVal.length) {
          // 全选
          this.checkedAllService = true;
          this.isIndeterminateService = false;
        } else {
          // 部分选
          this.checkedAllService = true;
          this.isIndeterminateService = true;
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.dispatch >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
.attendant {
  font-weight: bold;
  font-size: 18px;
  color: #5b5b5b;
  margin-bottom: 30px;
  padding: 0 25px;
}
.attendant span {
  margin-left: 10px;
  font-size: 16px;
  color: #8f9399;
}
.hospital,
.signedHospital {
  background-color: #f7f8fa;
  margin: 30px 25px 10px 25px;
  padding-bottom: 10px;
}
.hospital {
  padding: 10px 30px;
}
.signedHospital {
  position: relative;
  max-height: 464px;
  overflow-y: auto;
}
.content {
  margin: 30px 30px 10px 30px;
  background: #fff;
  display: flex;
}
.hspList,
.deptList,
.serviceList {
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #e7e7e7;
}
.hspList {
  flex: 1;
}
.deptList {
  flex: 1;
}
.serviceList {
  flex: 1;
}
.hsp-name {
  color: #606266;
  font-weight: 500;
  cursor: pointer;
}
.hospital >>> .el-tag {
  margin: 0 10px 10px 0;
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  white-space: normal;
  height: auto;
  padding: 0 10px;
  font-size: 12px;
  color: #409eff;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.hospital >>> .el-tag .el-icon-close {
  border-radius: 50%;
  text-align: center;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  height: 12px;
  width: 12px;
  line-height: 12px;
  vertical-align: middle;
  top: -1px;
  right: -5px;
  color: #949da6;
  border: 1px solid #949da6;
}
.hospital >>> .el-tag .el-icon-close:hover {
  color: #fff;
  border: 1px solid #e6f1fc;
}
.title {
  position: relative;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #5b5b5b;
  font-size: 16px;
  margin-bottom: 10px;
}
.hsp {
  padding: 10px 15px;
}
.activeHsp {
  background: #f4f7ff;
  cursor: pointer;
}
.commonHsp {
  background: #fff;
  cursor: pointer;
}
.checkedAll {
  margin: 10px 15px;
}
.group {
  margin: 20px 36px 0;
}
.empty-block {
  text-align: center;
  img {
    width: 107px;
    height: 67px;
  }
}
.el-tree {
  padding: 0 10px;
  position: relative;
  cursor: default;
  background: #fff;
  color: #606266;
}
.deptList >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #fff !important;
}
.serviceList >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #fff !important;
}
.filter-box {
  padding: 0 15px;
}
.filter-box >>> .el-input__inner {
  border-radius: 20px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/SetupDispatchPvg.vue